import commonService from './commonService'

const getAll = async (signal = null) => {
  return await commonService.getAll('zones', signal)
}

const getAllByProvince = async (provinceId, signal = null) => {
  return await commonService.getAllBy('provinces', provinceId, 'zones', signal)
}

const get = async (id) => {
  return await commonService.get('zones', id)
}

export default { getAll, getAllByProvince, get }
